<div class="row" *ngIf="!loading">
  <app-property-attributes-form class="property-form-group col-lg-6" *ngFor="let group of groups" [prop]="prop"
    [group]="group" [values]="propValues"
    [openInEditMode]="groupOpenedInEdition[group.code]"></app-property-attributes-form>
</div>